import { useState, useEffect } from 'react'

interface ProgressiveImageProps {
  src: string
  placeholder?: string
  alt: string
  className?: string
}

const ProgressiveImage = ({ src, placeholder, alt, className = '' }: ProgressiveImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    // 预加载高清图
    const img = new Image()
    img.src = src
    img.onload = () => {
      setIsLoaded(true)
    }
  }, [src])

  // 加载完成：显示高清图（正常样式）
  // 加载中：显示模糊占位图
  if (isLoaded) {
    return (
      <img
        src={src}
        alt={alt}
        className={className}
      />
    )
  }

  // 加载中显示模糊占位图
  return (
    <img
      src={placeholder || src}
      alt={alt}
      className={`${className} progressive-placeholder`}
    />
  )
}

export default ProgressiveImage
